module.exports = __webpack_public_path__ + "img/estandarizado.0d6843e9.gif";